"use strict";

// Dry weather data calls catch basins "bmpFcs", but their inspection URL is under "catchBasin".
const INSPECTION_URL_ASSET_TYPES = {
  outfall: "outfall",
  bmpFcs: "catchBasin",
  manhole: "manhole",
};

const DryWeatherFunctions = function () {
  var openFactSheet = function (id, assetType) {
    UrlRoutes.go("idde-fact-sheet", { id: CompositeAssetId.build(assetType, id) });
  };

  var openDryWeatherScreening = function (id, assetType, screeningId, inspectionType = null) {
    const inspectionUrlAssetType = INSPECTION_URL_ASSET_TYPES[assetType];
    if (!inspectionUrlAssetType) {
      throw new Error(`Unsupported asset type for dry weather screening: ${assetType}`);
    }

    let url = InspectionUrl.getForCurrentView(inspectionUrlAssetType, id, screeningId);

    if (inspectionType) {
      url += `?${new URLSearchParams({ inspectionType })}`;
    }

    UrlRoutes.navigate(url);
  };

  var deleteDryWeatherScreening = function ($todoTr, screeningId, assetType, assetId) {
    if (assetType === "outfall") {
      OutfallInspectionHistory.confirmDeleteHistory($todoTr, { id: screeningId });
    } else if (assetType === "bmpFcs") {
      BmpFunctions.confirmDeleteHistory($todoTr, {
        id: screeningId,
        assetType: "routineMaintenance",
      });
    } else if (assetType === "manhole") {
      MessageModal.showDeleteRecordModal(function () {
        ApiCalls.deleteManholeInspection(screeningId).then(() =>
          InspectableAssetCache.refreshAsset("manhole", assetId),
        );
        $todoTr.remove();
      });
    } else {
      throw new Error(`Unsupported asset type for dry weather screening: ${assetType}`);
    }
  };

  var getDryWeatherLayerPopupHtml = function (data) {
    const displayIllicitActivity =
      IncidentInvestigationConstants.getIllicitActivityOptions().getObjectWith(
        "value",
        data.lastIncident?.illicitActivity,
      )?.name;

    return nunjucks.render("popups/dryWeatherPopup.njk", {
      ...data,
      displayIllicitActivity,
      popupColor: DryWeatherIcon.getIconColor(data.dryWeatherCondition, data.isDue),
      showDeleteOutfallButton: data.assetType === "outfall",
    });
  };

  var loadPopupListeners = function (data, $element) {
    $element.off("click", ".open-dry-weather-screening");
    $element.on("click", ".open-dry-weather-screening", () =>
      openDryWeatherScreening(data.id, data.assetType, null, "idde-screening"),
    );

    $element.off("click", ".open-dry-weather-screening-follow-up");
    $element.on("click", ".open-dry-weather-screening-follow-up", () =>
      openDryWeatherScreening(data.id, data.assetType, null, "idde-rescreen"),
    );

    $element.off("click", ".popup-fact-sheet-button");
    $element.on("click", ".popup-fact-sheet-button", () => openFactSheet(data.id, data.assetType));
  };

  return {
    openFactSheet,
    openDryWeatherScreening,
    deleteDryWeatherScreening,
    getDryWeatherLayerPopupHtml,
    loadPopupListeners,
  };
};

module.exports = DryWeatherFunctions();

const ApiCalls = require("../apiCalls");
const CompositeAssetId = require("../general/compositeAssetId");
const DryWeatherIcon = require("./dryWeatherIcon");
const InspectableAssetCache = require("../offline/inspectableAssetCache");
const InspectionUrl = require("../routes/2nform/inspectionUrl");
const IncidentInvestigationConstants = require("./incidentInvestigation/incidentInvestigationConstants");
const MessageModal = require("../modals/messageModal");
const UrlRoutes = require("../routes/urlRoutes");
const OutfallInspectionHistory = require("../outfalls/outfallInspectionHistory");
const BmpFunctions = require("../modals/bmpFunctions");
